import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Fragment } from 'react';
import DropdownItem from './DropdownItem';
import CompetencyFilterStore from '../Store';
import { CompetencyFilterOptions } from '../Types';

interface Props {
  competencyFilterStore: CompetencyFilterStore;
  options: CompetencyFilterOptions[];
}

const Dropdown: React.FC<Props> = ({ competencyFilterStore, options }) => (
  <Transition
    as={Fragment}
    enter="transition ease-out duration-100"
    enterFrom="transform opacity-0 scale-95"
    enterTo="transform opacity-100 scale-100"
    leave="transition ease-in duration-75"
    leaveFrom="transform opacity-100 scale-100"
    leaveTo="transform opacity-0 scale-95"
  >
    <Menu.Items
      className={clsx(
        'bg-white drop-shadow-md rounded-md mt-2 border-1',
        'border-solid border-gray-300 py-2 pl-2 pr-1 z-[3] absolute',
      )}
    >
      <div className="py-1 max-h-96 relative overflow-scroll overflow-x-hidden">
        {options.map((option) => (
          <DropdownItem
            key={option.id}
            option={option}
            competencyFilterStore={competencyFilterStore}
          />
        ))}
      </div>
    </Menu.Items>
  </Transition>
);

export default observer(Dropdown);
